import { useMutation } from 'react-query';
import { useDispatch } from 'react-redux';

import { MaxActiveLinksError } from '@app/features/contractLink/contractLinkCreate';
import { useWorkspaceId } from '@app/hooks/useWorkspaceId';
import { getEditingDocumentsFile } from '@app/store/transport-layer/document/editing-documents/file';
import { Dispatch } from '@app/store/types';

import { checkContractLinkLimits, contractLinkCreateFileUpload } from '../../actions';

export default function useStartContractLinkByEditingDocument() {
  const dispatch = useDispatch<Dispatch>();

  const workspaceId = useWorkspaceId();

  return useMutation<void, Error, { id: string; title: string }>(async ({ id, title }) => {
    const checkLimitResultAction = await dispatch(checkContractLinkLimits());

    if (checkContractLinkLimits.fulfilled.match(checkLimitResultAction)) {
      const { payload } = checkLimitResultAction;
      if (payload.isLimitExceeded) {
        /**
         * TODO: @Juyeong-Byeon 이슈 논의 후 처리
         * 비즈니스 규칙에 따른 분기를 try catch로 처리하는 부분에 대하여
         * https://github.com/modusign/modusign-client/issues/9103
         *
         */
        throw new MaxActiveLinksError(payload.concurrentActiveLinksLimit, payload.activeLinkCount);
      }

      const url = await getEditingDocumentsFile(workspaceId, id);

      await dispatch(contractLinkCreateFileUpload({ name: `${title}.pdf`, url }));
    }

    if (checkContractLinkLimits.rejected.match(checkLimitResultAction)) {
      throw new Error(checkLimitResultAction.error.message);
    }
  });
}
